import { createSelector } from '@reduxjs/toolkit';
import { contractsNotDeleted } from './contracts-not-deleted';
import type { ContractViewModel } from '@trinnvis/dabih-api-client';
import { employeeNamesById } from '../employees/employee-names-by-id';
import { partnerNamesById } from '../partners/partner-names-by-id';

export const contractsNotDeletedWithParties = createSelector(
  contractsNotDeleted,
  employeeNamesById,
  partnerNamesById,
  (contracts, employees, partners) => {
    const withParties = (e: ContractViewModel): ContractViewModel & { nameWithParties: string } => {
      const employeeNames: string[] =
        e.employees === undefined
          ? []
          : e.employees.map((id) => {
              return employees[id];
            });
      employeeNames.sort();
      const partnerNames: string[] =
        e.partners === undefined
          ? []
          : e.partners.map((id) => {
              return partners[id];
            });
      partnerNames.sort();

      const names = [...employeeNames, ...partnerNames];
      return Object.assign({}, e, {
        party: names.join(', '),
        nameWithParties: e.name + (names.length ? ' (' + names.join(', ') + ')' : ''),
      });
    };

    return contracts.map(withParties);
  },
);
